export enum COSTING_STRATEGY {
  INCLUDE = 'INCLUDE',
  EXCLUDE = 'EXCLUDE',
}

export enum SELECTION_CRITERIA {
  CUSTOM = 'CUSTOM',
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  LOWEST_PRICE = 'LOWEST_PRICE',
  SHORTEST_LEAD_TIME = 'SHORTEST_LEAD_TIME',
  LONGEST_LEAD_TIME = 'LONGEST_LEAD_TIME',
  VENDOR_THYSSENKRUPP = 'VENDOR_THYSSENKRUPP',
  VENDOR_ONLINE_METALS = 'VENDOR_ONLINE_METALS',
}
